import { forwardRef } from "react";

import {
  ARTICLE_DEFAULTS,
  type TArticleProps,
} from "@/ui/components/layout/Article";
import { cn } from "@/ui/lib/utils";

export const Article = forwardRef<HTMLElement, TArticleProps>(
  (
    {
      "data-component": component = ARTICLE_DEFAULTS["data-component"],
      className,
      children,
      ...props
    },
    ref,
  ) => (
    <article
      {...props}
      ref={ref}
      data-component={component}
      className={cn(className)}
    >
      { children }
    </article>
  ),
);

Article.displayName = "Article";
